<template>
  <as-dialogo
    ref="dialogoCodigoValidacao"
    title="Código de Validação"
    max-width="400px"
    sem-padding
  >
    <v-container fluid class="pa-2 pb-5">
      <v-col sm="12">
        <p>
          Informe o código de validação enviado para o e-mail
          <b>
            <big>{{ email }}</big>
          </b>
        </p>
      </v-col>
      <v-col sm="12" class="pt-0 pb-0">
        <v-text-field
          styled="font-size: 20px"
          label="Código"
          ref="codigo"
          text-xs-center
          autofocus
          maxlength="6"
          class="centered-input codigo-ativacao"
          v-model="codigo"
          :error-messages="msgErro"
          @keypress.native.enter="validar"
        ></v-text-field>
      </v-col>
      <v-col sm="12" class="pt-2 pb-0" style="text-align: right">
        <v-btn
          depressed
          color="default"
          class="mr-4"
          v-show="exibirReenviarCodigo"
          @click="reenviarCodigo"
          :loading="loading"
          :disabled="loading"
        >Reenviar</v-btn>
        <v-btn
          depressed
          color="primary"
          @click="validar"
          :disabled="codigo.length < 6 || loading"
          :loading="loading"
        >Validar</v-btn>
      </v-col>
    </v-container>
  </as-dialogo>
</template>

<script>
import config from "@/config";
import ServicesUsers from "@/services/users.js";

export default {
  props: {
    email: { type: String }
  },
  name: "CodigoValidacao",

  data() {
    return {
      codigo: "",
      loading: false,
      exibirReenviarCodigo: false,
      msgErro: "",
      passwordReset: false
    };
  },
  methods: {
    abrir(params) {
      this.$refs.dialogoCodigoValidacao.abrir();
      this.exibirReenviarCodigo = params.reenviarCodigo || false;
      this.passwordReset = params.passwordReset || false;
    },

    fechar(value) {
      this.$refs.dialogoCodigoValidacao.fechar();
      this.codigo = "";
    },

    async reenviarCodigo() {
      this.loading = true;
      this.codigo = "";
      try {
        if (this.passwordReset) {
          await ServicesUsers.sendLinkReset(this.email, true);
        } else {
          await ServicesUsers.reenviarEmailCodigoAtivacao(this.email);
        }
        this.$eventbus.notificar(
          "O codigo de validação foi reenviado para o email com sucesso!"
        );
        this.exibirReenviarCodigo = false;
        this.$refs.codigo.focus();
      } catch (error) {
        if (typeof error.response !== "undefined") {
          this.$eventbus.erro(error.response.data.msg);
        }
      }
      this.loading = false;
    },

    async validar() {
      this.exibirReenviarCodigo = false;
      this.loading = true;
      try {
        if (this.passwordReset) {
          await ServicesUsers.codigoReset(this.email, this.codigo);
        } else {
          await ServicesUsers.codigoAtivacao(this.email, this.codigo);
        }
        this.codigo = "";
        this.$refs.dialogoCodigoValidacao.fechar();
        this.$emit("success", this.passwordReset);
      } catch (error) {
        if (typeof error.response !== "undefined") {
          this.msgErro = error.response.data.msg;
          setTimeout(() => {
            this.msgErro = "";
          }, 3000);
          this.exibirReenviarCodigo = true;
          this.$refs.codigo.focus();
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style>
.centered-input input {
  text-align: center;
}
.codigo-ativacao input {
  font-size: 1.8rem !important;
}
</style>
